// extracted by mini-css-extract-plugin
export default {"button":"button__qoK2m","link":"link__TtXFw","disabled":"disabled__Pbnmb"};